export default __webpack_public_path__ + "static/media/gl-ex3.effc2d5c.jpg";